import { Tab as MuiTab } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTab = styled(MuiTab)({
  textTransform: "capitalize",
  color: "#8c1ec8",
  fontSize: "1rem",
  fontWeight: 500,
  "&.Mui-selected": {
    color: "#8c1ec8",
    fontWeight: 700,
  },
  "&:hover": {
    color: "#8c1ec8",
    opacity: 0.8,
  },
});

export default StyledTab;
